import $ from 'wee-dom';
import $assets from 'wee-assets';
import $events from 'wee-events';
import $mediator from 'wee-mediator';
import $screen from 'wee-screen';
import { RouteHandler } from 'wee-routes';
import { _win } from 'core/variables';
import { $serialize } from 'core/types';
import Locations from './locations';
import Map from './map';
import KeyHelper from '../../scripts/keyhelper';

export default new RouteHandler({
    init() {
        const locationInstance = new Locations();

        if ($screen.size() > 4) {
            locationInstance.toggleView();
        }

        $assets.load({
            scripts: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBk4BFBK_mHDhba0XER5kZVyN2nmsKq3wk',
            success() {
                const mapInstance = new Map();
                const map = mapInstance.map;

                let locations = locationInstance.getQueryParam();
                mapInstance.setMarkers(locations);

                $events.on(':filter', 'change', (e, el) => {
                    const $el = $(el);
                    const val = $el.val();
                    const query = { [$el.attr('name')]: val };
                    const path = $el.parent().data('type');
                    const url = val ? `/${path}?${$serialize(query)}` : `/${path}`;

                    _win.history.replaceState(null, null, url);

                    let locations = locationInstance.filterLocations(val.length ? val : 'location');

                    mapInstance.setMarkers(locations).setMapZoom(11);
                    e.preventDefault();
                });

                $events.on(':locationView', {
                    click(e, el) {
                        mapInstance.closeInfoWindow();
                        $mediator.emit('change.view', el);
                        e.preventDefault();
                    },
                    keypress(e, el) {
                        if (KeyHelper.isEnter(e)) {
                            mapInstance.closeInfoWindow();
                            $mediator.emit('change.view', el);
                        }
                        e.preventDefault();
                    },
                });
            },
            error(e) {
                console.error(e);
            },
        });
    },
});
